import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEligibilityData } from "../useEligibilityData";
import moment from "moment";
import { useStageGuard } from "../useStageGuard";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import Loader from "../../../components/atoms/Loader";
import eligStyles from "../index.module.css";

const DEMO_DATA = {
  loanAmount: 75000,
  emi: 6500,
  tenure: 12,
  emiFirstDate: "2026-05-01",
  sanctionLetterUrl: null,
};

function EligibilitySanctionDetails() {
  const navigate = useNavigate();
  const userData = useEligibilityData();

  useStageGuard(userData?.userId, userData?.applicationId, 8);

  const urlData = JSON.parse(sessionStorage.getItem("eligibility_url_data") || "{}");
  const loanTenure = urlData?.loanTenure || null;

  const [sanctionData, setSanctionData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let appId = userData?.applicationId;
    if (!appId) {
      const saved = JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");
      appId = saved?.applicationId;
    }
    if (!appId) { setSanctionData(DEMO_DATA); return; }

    const token = sessionStorage.getItem("eligibility_auth_token");
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/sanction-details?applicationId=${appId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((res) => res.json())
      .then((result) => setSanctionData(result?.data || DEMO_DATA))
      .catch(() => setSanctionData(DEMO_DATA))
      .finally(() => setLoading(false));
  }, [userData?.applicationId]);

  const handleDownload = () => {
    if (!sanctionData?.sanctionLetterUrl) return;
    const path = sanctionData.sanctionLetterUrl.split("amazonaws.com/")[1];
    const token = sessionStorage.getItem("eligibility_auth_token");
    setDownloading(true);
    fetch(
      `${process.env.REACT_APP_DASHBOARD_URL}/file/url-content-sl?path=${path}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
      .then((res) => res.json())
      .then((data) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = data.data;
        downloadLink.download = "sanction-letter.pdf";
        downloadLink.click();
      })
      .catch(() => setError("Failed to download sanction letter."))
      .finally(() => setDownloading(false));
  };

  const handleContinue = () => {
    if (submitting) return;
    setSubmitting(true);
    const token = sessionStorage.getItem("eligibility_auth_token");
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/application/send-tnc-mail`, {
      method: "POST",
      headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
      redirect: "follow",
      body: JSON.stringify({ user: btoa(`${userData?.userId} ${userData?.applicationId}`) }),
    })
      .then((res) => res.json())
      .then(() => navigate("/eligibility/selfie", { state: { data: userData } }))
      .catch(() => setError("Failed to send confirmation. Please try again."))
      .finally(() => setSubmitting(false));
  };

  return (
    <div className={eligStyles.body}>
      <div className={eligStyles.backdrop}>
        <Navbar />
        <div className={eligStyles.main}>
          <div className={eligStyles.cardWrapper}>
            <div className={eligStyles.container}>
               <div className={eligStyles.cardHeader}>
                    <div style={{
                      width: "2.4rem", height: "2.4rem", borderRadius: "50%",
                      background: "#F4E5DD", display: "flex", alignItems: "center",
                      justifyContent: "center", flexShrink: 0,
                    }}>
                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
  <path d="M14 2H6C4.895 2 4 2.895 4 4V20C4 21.105 4.895 22 6 22H18C19.105 22 20 21.105 20 20V8L14 2Z" fill="#d32028" opacity="0.15" stroke="#d32028" strokeWidth="1.5" strokeLinejoin="round"/>
  <polyline points="14,2 14,8 20,8" stroke="#d32028" strokeWidth="1.5" strokeLinejoin="round"/>
  <line x1="8" y1="13" x2="16" y2="13" stroke="#d32028" strokeWidth="1.5" strokeLinecap="round"/>
  <line x1="8" y1="17" x2="13" y2="17" stroke="#d32028" strokeWidth="1.5" strokeLinecap="round"/>
</svg>


                    </div>
                    <p className={eligStyles.cardTitle}>Sanction Details</p>
                  </div>
              {loading && <Loader />}

              {!loading && sanctionData && (
                <>
                  {/* ── Application Status ── */}
                  {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.1rem" }}>
                    <div>
                      <span style={{ fontSize: "0.65rem", fontWeight: 600, color: "#999", letterSpacing: "0.8px", textTransform: "uppercase", display: "block", marginBottom: "0.25rem" }}>
                        Application Status
                      </span>
                     
                    </div>
                     <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                        <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#22c55e", display: "inline-block", flexShrink: 0 }} />
                        <span style={{ fontSize: "1rem", fontWeight: 700, color: "#22c55e" }}>Sanctioned</span>
                      </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "0.3rem 0.7rem", borderRadius: "20px" }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2L3 7V12C3 16.55 6.84 20.74 12 22C17.16 20.74 21 16.55 21 12V7L12 2Z" fill="#22c55e" opacity="0.2" />
                        <path d="M9 12L11 14L15 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span style={{ fontSize: "0.75rem", fontWeight: 700, color: "#22c55e" }}>Verified</span>
                    </div>
                  </div> */}

                  {/* ── Total Loan Amount ── */}
                  <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: "14px", padding: "1.1rem 1.25rem", marginBottom: "0.75rem" }}>
                    <p style={{ fontSize: "0.82rem", color: "#666", margin: "0 0 -0.2rem" }}>Total Loan Amount Sanctioned</p>
                    <p style={{ fontSize: "1.5rem", fontWeight: 800, color: "#1a1a2e", margin: "0 0 -0.2rem", letterSpacing: "-1px", fontFamily: "Outfit, sans-serif" }}>
                      ₹{sanctionData?.loanAmount?.toLocaleString("en-IN")}
                    </p>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="9" stroke="#aaa" strokeWidth="1.6" />
                        <path d="M12 11V16" stroke="#aaa" strokeWidth="1.8" strokeLinecap="round" />
                        <circle cx="12" cy="8" r="0.8" fill="#aaa" />
                      </svg>
                      <span style={{ fontSize: "0.74rem", color: "#aaa" }}>Disbursement subject to final verification</span>
                    </div>
                  </div>

                  {/* ── Monthly EMI + First EMI Date ── */}
                  <div style={{ display: "flex", gap: "0.65rem", marginBottom: "0.75rem" }}>
                    <div style={{ flex: 1, background: "#fff", border: "1px solid #e8e8e8", borderRadius: "12px", padding: "0.9rem 1rem" }}>
                      <p style={{ fontSize: "0.65rem", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px", margin: "0 0 -0.2rem" }}>Monthly EMI</p>
                      <p style={{ fontSize: "1rem", fontWeight: 800, color: "#1a1a2e", margin: "0.5rem 0 0.2rem", fontFamily: "Outfit, sans-serif" }}>
                        ₹ {sanctionData?.emi?.toLocaleString("en-IN")}
                      </p>
                      <p style={{ fontSize: "0.72rem", color: "#888", margin: 0 }}>
                        For {loanTenure || "—"} Months
                      </p>
                    </div>
                    <div style={{ flex: 1, background: "#fff", border: "1px solid #e8e8e8", borderRadius: "12px", padding: "0.9rem 1rem" }}>
                      <p style={{ fontSize: "0.65rem", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px", margin: "0 0 0.35rem" }}>First EMI Date</p>
                      <p style={{ fontSize: "1rem", fontWeight: 800, color: "#1a1a2e", margin: "0 0 0.2rem", fontFamily: "Outfit, sans-serif" }}>
                        {moment(sanctionData?.emiFirstDate).format("DD MMM YYYY")}
                      </p>
                      <p style={{ fontSize: "0.72rem", color: "#888", margin: 0 }}>Next Payment</p>
                    </div>
                  </div>

                  {/* ── Total Interest + APR ── */}
                  <div style={{ display: "flex", gap: "0.65rem", marginBottom: "0.75rem" }}>
                    <div style={{ flex: 1, background: "#fff", border: "1px solid #e8e8e8", borderRadius: "12px", padding: "0.9rem 1rem" }}>
                      <p style={{ fontSize: "0.65rem", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px", margin: "0 0 -0.2rem" }}>Total Interest</p>
                      <p style={{ fontSize: "1rem", fontWeight: 800, color: "#1a1a2e", margin: "0.5rem 0 0.2rem", fontFamily: "Outfit, sans-serif" }}>
                        {sanctionData?.totalInstallment != null && sanctionData?.totalPrincipal != null
                          ? `₹ ${Math.max(0, sanctionData.totalInstallment - sanctionData.totalPrincipal).toLocaleString("en-IN")}`
                          : "—"}
                      </p>
                      <p style={{ fontSize: "0.72rem", color: "#888", margin: 0, whiteSpace: "nowrap" }}>
                        Over {loanTenure || "—"} months tenure
                      </p>
                    </div>
                    <div style={{ flex: 1, background: "#fff", border: "1px solid #e8e8e8", borderRadius: "12px", padding: "0.9rem 1rem" }}>
                      <p style={{ fontSize: "0.65rem", fontWeight: 600, color: "#999", textTransform: "uppercase", letterSpacing: "0.6px", margin: "0 0 -0.2rem" }}>APR</p>
                      <p style={{ fontSize: "1rem", fontWeight: 800, color: "#1a1a2e", margin: "0.5rem 0 0.2rem", fontFamily: "Outfit, sans-serif" }}>
                        {sanctionData?.aprIrr != null ? `${sanctionData.aprIrr}%` : "—"}
                      </p>
                      <p style={{ fontSize: "0.72rem", color: "#888", margin: 0 }}>Annualized Rate</p>
                    </div>
                  </div>

                </>
              )}

              {error && (
                <p style={{ color: "#d32028", fontSize: "0.85rem", marginTop: "0.75rem" }}>{error}</p>
              )}
            </div>

            {/* ── Continue button ── */}
            <div style={{ padding: "0rem 1.25rem 1rem", display: "flex", flexDirection: "row", alignItems: "center", gap: "0.6rem",justifyContent:'center' }}>
              <button
                onClick={handleContinue}
                disabled={loading || submitting}
                style={{
                  width: "45%",
                  padding: "0.9rem 1.5rem",
                  background: loading || submitting ? "#aaa" : "#d32028",
                  color: "#fff",
                  border: "none",
                  borderRadius: "60px",
                  fontSize: "0.95rem",
                  fontWeight: 700,
                  fontFamily: "Outfit, sans-serif",
                  cursor: loading || submitting ? "not-allowed" : "pointer",
                  letterSpacing: "0.3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                }}
              >
                {submitting ? "Please wait..." : (
                  <>
                    Continue
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M13 6L19 12L13 18" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </>
                )}
              </button>
              {process.env.REACT_APP_CURRENT !== 'prod' && (
                <button
                  onClick={() => navigate("/eligibility/sanction-letter", { state: { data: userData, sanctionLetterUrl: sanctionData?.sanctionLetterUrl } })}
                  style={{ background: "none", border: "none", color: "#bbb", fontSize: "0.78rem", cursor: "pointer", fontFamily: "Outfit, sans-serif", textDecoration: "underline" }}
                >
                  Skip
                </button>
              )}
            </div>
            <Footer light />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EligibilitySanctionDetails;
